'use client'

/* eslint-disable @next/next/no-img-element */
import { cn } from '@gyym/ui'
import { useCallback, useId, useState } from 'react'

import { BRAND_LOGOS } from '../_data'
import { Lines, LpModal, ModalPhotoRow } from './LpModal'

/** ポイント2 の提携ブランドロゴ一覧。クリックで紹介モーダルを開く */
export const BrandLogos = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null)
  const labelId = useId()
  const close = useCallback(() => setOpenIndex(null), [])
  const brand = openIndex === null ? null : BRAND_LOGOS[openIndex]

  return (
    <>
      {BRAND_LOGOS.map((logo, index) => (
        <button
          key={logo.src}
          type="button"
          onClick={() => setOpenIndex(index)}
          aria-haspopup="dialog"
          aria-label={`${logo.alt}の紹介を見る`}
          className={cn(
            'flex w-[21%] flex-col items-center justify-center max-[540px]:w-[33%] max-[540px]:px-[7px] max-[540px]:pb-[7px] max-[540px]:pt-0',
            index === 0 ? 'p-5' : 'px-5 pb-5 pt-0',
          )}
        >
          <img
            src={logo.src}
            alt={logo.alt}
            className={cn(
              'w-full object-contain',
              index === 0 && 'max-w-[90%]',
            )}
            loading="lazy"
          />
        </button>
      ))}

      <LpModal
        open={brand !== null}
        onClose={close}
        labelId={labelId}
        variant="brand"
      >
        {brand && (
          <>
            <p
              id={labelId}
              className="my-5 text-center font-josefin-sans text-[18px] font-semibold leading-[25.2px] tracking-[1.8px] text-[#EEEEEE]"
            >
              {brand.modal.title}
            </p>
            <p className="mx-[15px] mb-5 max-w-[calc(100%-30px)] text-center text-[16px] font-medium leading-[27.2px] tracking-[1.6px] text-[#EEEEEE]">
              <Lines lines={brand.modal.subtitle} />
            </p>
            <p className="mx-5 mb-5 max-w-[calc(100%-40px)] text-left text-[14px] font-normal leading-[23.8px] tracking-[1.4px] text-[#EEEEEE]">
              <Lines lines={brand.modal.body} />
            </p>
            <ModalPhotoRow photo={brand.modal.photo} logo={brand.modal.logo} />
          </>
        )}
      </LpModal>
    </>
  )
}
